// crm-web/frontend/src/hooks/useAnalyticsTab.js
// Hook para el tab activo del dashboard de analiticas.
// Persistencia en localStorage paralela a useAnalyticsRange.

import { useState, useCallback } from 'react'
import { TABS, DEFAULT_TAB } from '../components/analytics/tabRegistry'

const STORAGE_KEY = 'analytics_active_tab'

function isValidTabId(id) {
  return TABS.some(t => t.id === id)
}

function getInitialTab() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved && isValidTabId(saved)) return saved
  } catch {
    // localStorage no disponible
  }
  return DEFAULT_TAB
}

export default function useAnalyticsTab() {
  const [tabId, setTabIdState] = useState(getInitialTab)

  const setTabId = useCallback((newId) => {
    if (!isValidTabId(newId)) return
    setTabIdState(newId)
    try {
      localStorage.setItem(STORAGE_KEY, newId)
    } catch {
      // silencioso
    }
  }, [])

  return { tabId, setTabId }
}
